<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Iktatgató · {{ oldalCim }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="ikt-lap">
    <router-outlet></router-outlet>
  </div>
</ion-content>
